import { oz } from '@weft/utils';
import { PAYMENT_TERMS, PaymentTermSchema } from '../../primitives';
import { BillingIntervalSchema } from '../../primitives/billing-interval-schema';
import { PlanDurationSchema } from './plan-duration-schema';

export const PlanBillingDataSchema = oz.object({
  billingInterval: BillingIntervalSchema,
  duration: PlanDurationSchema,
  paymentTerm: PaymentTermSchema.default(PAYMENT_TERMS.Postpayment),
  autoRenewal: oz.boolean().default(false),
  proRated: oz.boolean().default(true),
}).openapi('PlanBillingData');

export type PlanBillingData = oz.infer<typeof PlanBillingDataSchema>;